const GA_MEASUREMENT_ID: string = process.env.NEXT_PUBLIC_GA_ID || "";

export const initGA = () => {
  if (!GA_MEASUREMENT_ID) {
    return;
  }
  if (document.getElementById('ga-script')) {
    return;
  }

  const script = document.createElement('script');
  script.id = 'ga-script';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  const inlineScript = document.createElement('script');
  inlineScript.innerHTML = `window.dataLayer = window.dataLayer || [];\nfunction gtag(){dataLayer.push(arguments);}\ngtag('js', new Date());\ngtag('config', '${GA_MEASUREMENT_ID}');`;
  document.head.appendChild(inlineScript);
};

export const trackPageview = (url: string) => {
  if (!GA_MEASUREMENT_ID) {
    return;
  }
  if (typeof window.gtag === 'function') {
    window.gtag('config', GA_MEASUREMENT_ID, { page_path: url });
  }
};

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}
